import React, { useState } from "react";
import { observer } from "mobx-react-lite";

import TimeAtPosition from "./TimeAtPosition";

interface SliderTooltipProps {
  isThumbActive: boolean;
  seekHoverPosition: number;
  trackWidth: number;
  videoDuration: number;
}

export default observer(function SliderTooltip(props: SliderTooltipProps) {
  const { isThumbActive, seekHoverPosition, trackWidth, videoDuration } = props;

  const [hoverTimeElement, setHoverTimeElement] = useState<HTMLDivElement | null>(null);

  const getTooltipPosition = (): object => {
    let position: number = hoverTimeElement
      ? seekHoverPosition - hoverTimeElement.offsetWidth / 2
      : 0;
    return { transform: `translateX(${position}px)` };
  };

  if (!videoDuration) return <></>;

  return (
    <div
      className={isThumbActive ? "hover-time active" : "hover-time"}
      style={getTooltipPosition()}
      ref={(ref) => setHoverTimeElement(ref)}
    >
      {videoDuration && (
        <TimeAtPosition
          seekHoverPosition={seekHoverPosition}
          trackWidth={trackWidth}
          videoDuration={videoDuration}
        />
      )}
    </div>
  );
});
